import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';

// Third-party packages.
import Helmet from 'react-helmet';
import * as dayjs from 'dayjs';
import * as isoWeek from 'dayjs/plugin/isoWeek';

// Types
import LoginTags from "../../../types/LoginsTags";
import LoginsDataTable from "../../../types/LoginsDataTable";

// Views.
import List from './List';
import Detail from './Detail';
import Breadcrumb from "../../../container/breadcrumb";
import HeaderActions from "../../../container/header_actions";

// Api
import LoginApi from "../../../api/LoginApi";

// DayJS plugins - note, the position of these in this file are important.
dayjs.extend(isoWeek.default);

function Logins(props: { toggleMenu: Function, loginRequired: boolean, isAdmin: boolean }) {
    const [logins, setLogins] = useState<LoginsDataTable[]>([]);
    const [assignedTags, setAssignedTags] = useState<LoginTags[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const isAdmin = props.isAdmin
    const navigate = useNavigate();

    useEffect(() => {
        if (!props.loginRequired) {
            navigate(`/not-found`)
        }
    }, [props.loginRequired]);

    useEffect(() => {
        const controller = new AbortController();
        void getLogins();
        void getTags(controller.signal);
        return () => controller.abort();
    }, []);

    const getLogins = async() => {

        // Get Logins
        let logins: LoginsDataTable[] = await LoginApi.getLogins()

        setLoading(false)
        setLogins(logins)
    }

    const getTags = async (signal?: AbortSignal) => {
        let loginTags: any[] = await LoginApi.getTags(signal);
        if (!signal?.aborted) {
            setLoading(false);
            setAssignedTags(loginTags);
        }
    };

    const refresh = () => {
        setLogins([]);
        setAssignedTags([]);
        setLoading(true);
        void getLogins();
        void getTags();
    };

    return (
        <div id="content">
            <Helmet>
                <title>Logins - Settings - DBmarlin</title>
                <meta name="description" content="Manage nogins"/>
            </Helmet>

            <div id="top-header-wrapper" className="row row-cols-lg-3 row-cols-sm-1 row-cols-md-2">
                <Breadcrumb heading="Logins">
                    <Link to="/admin">Settings</Link>
                    <span>Logins</span>
                </Breadcrumb>
               <HeaderActions toggleMenu={props.toggleMenu} refresh={() => refresh()}/>
            </div>

            <div className="row row-cols-1">
                <Routes>
                    <Route path="/:actionId/:loginId"
                           element={<Detail refresh={refresh} tags={assignedTags} logins={logins}/>}/>
                    <Route path="/:actionId"
                           element={<Detail refresh={refresh} tags={assignedTags} logins={logins}/>}/>
                    <Route path="/" element={<List loading={loading} isAdmin={isAdmin} loginDataTable={logins}
                                                   tags={assignedTags}/>}/>
                </Routes>
            </div>
        </div>
    );
}

Logins.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
};

export default Logins;
